// src/utils/navItems.js
import { ROUTE_ACCESS, ROLES, getStoredRoleNormalized, isRoleAllowed } from "../auth/permissions";

import { FaHome, FaUserCog, FaUsers, FaUserFriends, FaUserTie, FaCalendarAlt, FaWpforms, 
  FaBullhorn, FaPrayingHands, FaMicrophoneAlt, FaPhotoVideo, FaHandsHelping, FaRupeeSign, FaChartLine, FaCog } from "react-icons/fa";

export const NAV_ITEMS = [
  {
    key: "home",
    label: "Home",
    breadcrumb: "Home",
    path: "/home",
    icon: <FaHome />,
    allowedRoles: ROUTE_ACCESS["/home"]
  },
  {
    key: "enabledRoles",
    label: "Roles and Permissions",
    breadcrumb: "Roles and Permissions",
    path: "/enabledRoles",
    icon: <FaUserCog />,
    allowedRoles: ROUTE_ACCESS["/enabledRoles"]
  },
  {
    key: "userManagement",
    label: "User Management",
    breadcrumb: "User Management",
    path: "/userList",
    icon: <FaUsers />,
    allowedRoles: ROUTE_ACCESS["/userManagement"]
  },
  {
    key: "memberManagement",
    label: "Member Management",
    breadcrumb: "Member Management",
    path: "/memberList",
    icon: <FaUserFriends />,
    allowedRoles: ROUTE_ACCESS["/memberManagement"]
  },
  {
    key: "leaderManagement",
    label: "Leadership List",
    breadcrumb: "Leadership List",
    path: "/leaderList",
    icon: <FaUserTie />,
    allowedRoles: ROUTE_ACCESS["/leaderManagement"]
  },
  {
    key: "calendar",
    label: "Calendar & Events",
    breadcrumb: "Calendar & Events",
    path: "/eventList",
    icon: <FaCalendarAlt />,
    allowedRoles: ROUTE_ACCESS["/calendar"]
  },
  {
    key: "eventRequests",
    label: "Event Requests",
    breadcrumb: "Event Requests",
    path: "/requestList",
    icon: <FaWpforms />,
    allowedRoles: ROUTE_ACCESS["/eventRequests"]
  },
  {
    key: "announcements",
    label: "Announcements",
    breadcrumb: "Announcements",
    path: "/announcementList",
    icon: <FaBullhorn />,
    allowedRoles: ROUTE_ACCESS["/announcements"]
  },
  {
    key: "prayers",
    label: "Prayer Requests",
    breadcrumb: "Prayer Requests",
    path: "/prayerList",
    icon: <FaPrayingHands />,
    allowedRoles: ROUTE_ACCESS["/prayers"]
  },
  {
    key: "testimonies",
    label: "Testimonies",
    breadcrumb: "Testimonies",
    path: "/testimonyList",
    icon: <FaMicrophoneAlt />,
    allowedRoles: ROUTE_ACCESS["/testimonies"]
  },

  // Media & Content subpages.
  // parentGroup: "media" tells the sidebar to group these into a dropdown
  // at the position of the FIRST media item it encounters, preserving order.
  {
    key: "audio",
    label: "Audios",
    breadcrumb: "Media & Content > Audios",
    path: "/contentManagement/audio",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/audio"],
    parentGroup: "media"
  },
  {
    key: "bibleVersion",
    label: "Bible Versions",
    breadcrumb: "Media & Content > Bible Versions",
    path: "/contentManagement/bibleVersion",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/bibleVersion"],
    parentGroup: "media"
  },
  {
    key: "devotion",
    label: "Daily Devotions",
    breadcrumb: "Media & Content > Daily Devotions",
    path: "/contentManagement/devotion",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/devotion"],
    parentGroup: "media"
  },
  {
    key: "document",
    label: "Documents",
    breadcrumb: "Media & Content > Documents",
    path: "/contentManagement/document",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/document"],
    parentGroup: "media"
  },
  {
    key: "podcast",
    label: "Podcasts",
    breadcrumb: "Media & Content > Podcasts",
    path: "/contentManagement/podcast",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/podcast"],
    parentGroup: "media"
  },
  {
    key: "quote",
    label: "Quotes",
    breadcrumb: "Media & Content > Quotes",
    path: "/contentManagement/quote",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/quote"],
    parentGroup: "media"
  },
  {
    key: "streaming",
    label: "Sermons & Livestreams",
    breadcrumb: "Media & Content > Sermons & Livestreams",
    path: "/contentManagement/streaming",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/streaming"],
    parentGroup: "media"
  },
  {
    key: "verses",
    label: "Verse of the Day",
    breadcrumb: "Media & Content > Verse of the Day",
    path: "/contentManagement/verses",
    icon: <FaPhotoVideo />,
    allowedRoles: ROUTE_ACCESS["/contentManagement/verses"],
    parentGroup: "media"
  },

  {
    key: "volunteering",
    label: "Volunteer Forms",
    breadcrumb: "Volunteer Forms",
    path: "/volunteering/formList",
    icon: <FaHandsHelping />,
    allowedRoles: ROUTE_ACCESS["/volunteering"]
  },
  {
    key: "donations",
    label: "Donations",
    breadcrumb: "Donations",
    path: "/donationList",
    icon: <FaRupeeSign />,
    allowedRoles: ROUTE_ACCESS["/donations"]
  },
  {
    key: "reports",
    label: "Reports & Analytics",
    breadcrumb: "Reports & Analytics",
    path: "/reportList",
    icon: <FaChartLine />,
    allowedRoles: ROUTE_ACCESS["/reports"]
  },
  {
    key: "settings",
    label: "Settings",
    breadcrumb: "Settings",
    path: "/settings",
    icon: <FaCog />,
    allowedRoles: ROUTE_ACCESS["/settings"]
  }
];

// Returns only the pages the current user is allowed to see.
// Used by both the sidebar and the search bar.
export function getAllowedNavItems() {
  const currentRole = getStoredRoleNormalized();
  return NAV_ITEMS.filter((item) => {
    if (currentRole === ROLES.HEAD_ADMIN) return true;
    return isRoleAllowed(currentRole, item.allowedRoles);
  });
}
